// The public signup and waitlist pages' calls: JSON to the api on this origin, no session needed.
import { call, type Fetch } from "../http.js";

export interface SignupInput {
  readonly businessName: string;
  readonly name: string;
  readonly email: string;
  readonly consent: true;
}

export interface WaitlistInput {
  readonly name: string;
  readonly businessName: string;
  readonly contact: string;
  readonly city: string;
  readonly industry: string;
  readonly wants: string;
  readonly tooCheap: number;
  readonly cheap: number;
  readonly expensive: number;
  readonly tooExpensive: number;
  readonly consent: true;
}

export interface SignupApi {
  /** Makes the new business and emails its Owner a code; answers the business's id, which the code is for. */
  signUp(input: SignupInput): Promise<{ readonly tenantId: string }>;
  /** Verifies the emailed code: the business is set up and the Owner signed in. */
  verify(tenantId: string, email: string, code: string, trustDevice: boolean): Promise<void>;
  /** Asks for another code for the same business. */
  resend(tenantId: string, email: string): Promise<void>;
  joinWaitlist(input: WaitlistInput): Promise<void>;
}

export function createSignupApi(fetcher: Fetch = (input, init) => fetch(input, init)): SignupApi {
  return {
    signUp: (input) => call<{ tenantId: string }>(fetcher, "/api/signup", { json: input }),
    async verify(tenantId, email, code, trustDevice) {
      await call(fetcher, "/api/signup/verify", { json: { tenantId, email, code, trustDevice } });
    },
    async resend(tenantId, email) {
      await call(fetcher, "/auth/code", { json: { tenantId, email } });
    },
    async joinWaitlist(input) {
      await call(fetcher, "/api/waitlist", { json: input });
    },
  };
}
